import React from 'react'
import { Text } from 'react-native'
import { SuccessFailurePrompt } from '../../../../../ui/molecules/SuccessFailurePrompt'
import { PromptSuccessIcon } from '../../../../../assets/icons'
import { useTranslation } from 'react-i18next'
import { useResponsive } from '../../../../../utils/hooks'

export const LoanAppliedSuccessPrompt = ({ onClose }) => {
  const { sm } = useResponsive()
  const { t } = useTranslation('global')

  return (
    <SuccessFailurePrompt
      visible={true}
      icon={<PromptSuccessIcon />}
      title={t(
        'CreditApplication.submit-success-messages.with-invoice-previously-approved.title',
      )}
      message={
        <Text>
          {t(
            'CreditApplication.submit-success-messages.with-invoice-previously-approved.message',
          )}
        </Text>
      }
      exitable={true}
      onDismiss={onClose}
      buttonData={{
        title: 'Ok, got it',
        contentStyle: { width: '100%' },
        style: { width: 175 },
        onPress: onClose,
      }}
      contentContainerStyle={{ width: sm ? 600 : 340, marginBottom: 20 }}
      contentStyle={{ width: '100%' }}
      textContentBottomMargin={40}
    />
  )
}
